import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { generatePath, Link as RouterLink } from 'react-router-dom';

import Typography from '@mui/material/Typography';

import selectUser from '../../store/selectors/appSelector';
import { PRIMARY_COLOR } from '../../theme/colorConstants';
import { ROUTE_CONSTANTS } from '../../views/app/RouteBuilding/routeConstants';

import canLinkWorkerToUserDetails from './canLinkWorkerToUserDetails';

const WorkerNameLink = ({ name, userId, agencyId, sx, className, variant }) => {
  const user = useSelector(selectUser);
  const displayName = name ?? '';
  const canLink = canLinkWorkerToUserDetails({
    role: user?.role,
    userId,
    workerAgencyId: agencyId,
    recruiterAgencyId: user?.recruiter?.agency?.ID,
    workerName: displayName,
  });

  if (!canLink) {
    return (
      <Typography
        variant={variant}
        component="span"
        className={className}
        sx={{
          textDecoration: 'none',
          cursor: 'default',
          ...sx,
        }}
      >
        {displayName}
      </Typography>
    );
  }

  return (
    <Typography
      variant={variant}
      component={RouterLink}
      to={generatePath(`/${ROUTE_CONSTANTS.USERS_V2_DETAIL}`, { id: String(userId) })}
      className={className}
      onClick={(event) => event.stopPropagation()}
      sx={{
        color: PRIMARY_COLOR[70],
        textDecoration: 'underline',
        cursor: 'pointer',
        ...sx,
      }}
    >
      {displayName}
    </Typography>
  );
};

WorkerNameLink.propTypes = {
  name: PropTypes.string,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  agencyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  sx: PropTypes.shape({}),
  className: PropTypes.string,
  variant: PropTypes.string,
};

export default WorkerNameLink;
